export default "__VITE_ASSET__BkCBk8LX__"